import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { map } from 'rxjs/operators';
import { Service } from '../../models';
import { ApiService } from '../../utils/api.service';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class ServiceService {

  path = 'services';
  constructor(
    private api: ApiService,
  ) {
  }

  get(id: string, lang: string = ''): Observable<Service> {
    return this.api.get(`${this.path}/${id}`, null, lang);
  }

  getAll(lang: string = '', params: HttpParams = new HttpParams()): Observable<Service[]> {
    return this.api.get(this.path, params, lang);
  }

  save(service, lang: string = ''): Observable<Service> {
    const keywordToDestructSubject = ['getServices'];
    if (service.id) {
      return this.api.put(`${this.path}/${service.id}`, service, lang, keywordToDestructSubject);
    } else {
      return this.api.post(this.path, service, lang, keywordToDestructSubject);
    }
  }
}
